import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Bell } from "lucide-react";
import { useEffect, useState } from "react";
import { BottomNav } from "./BottomNav";
import { LangSwitcher } from "./LangSwitcher";
import { api } from "../lib/api";

export const AmbassadorLayout = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const load = () => api.get("/notifications")
      .then(({ data }) => setUnread(data.filter((n) => !n.read).length)).catch(() => {});
    load();
    window.addEventListener("vy:notifications-changed", load);
    return () => window.removeEventListener("vy:notifications-changed", load);
  }, [location.pathname]);

  return (
    <div className="vy-shell pb-20">
      <header className="sticky top-0 z-40 flex h-16 items-center gap-2 border-b border-border bg-card px-4">
        <button onClick={() => navigate("/")} data-testid="brand-home-btn"
          className="font-display text-lg font-bold tracking-tight">
          Vytali<span className="text-accent">Days</span>
        </button>
        <div className="ml-auto flex items-center gap-2">
          <button data-testid="notifications-btn" onClick={() => navigate("/notifications")}
            className="relative flex h-10 w-10 items-center justify-center rounded-full hover:bg-muted">
            <Bell className="h-5 w-5" />
            {unread > 0 && <span data-testid="notifications-unread-dot"
              className="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-accent" />}
          </button>
          <LangSwitcher />
        </div>
      </header>
      <main className="px-4 py-5">
        {children || <Outlet />}
      </main>
      <BottomNav />
    </div>
  );
};
